let selectStatus = document.querySelector("#form_602fb877c15ab #position");
let selectSuject = document.querySelector("#form_602fb877c15ab #subject");
const applicationMessage = document.querySelector(
  "#form_602fb877c15ab .application_message"
);

document.addEventListener("DOMContentLoaded", () => {
  if (selectStatus) {
    selectStatus.addEventListener("change", (e) => {
      if (
        selectStatus.value == "Étudiant" ||
        selectStatus.value == "En recherche d'emploi"
      ) {
        applicationMessage.classList.remove("hide");
      } else {
        applicationMessage.classList.add("hide");
      }
    });
  }

  if (selectSuject) {
    selectSuject.addEventListener("change", (e) => {
      if (
        selectSuject.value == "Candidature spontanée" ||
        selectSuject.value == "Recherche de stage/alternance"
      ) {
        applicationMessage.classList.remove("hide");
      } else {
        applicationMessage.classList.add("hide");
      }
    });
  }
});
